import { Component } from "@angular/core";
import {
  CompanyAttributes,
  DocumentClassAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  OrderExtraStatusAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";

import {
  MatSort,
  MatSortModule,
  Sort,
  SortDirection,
} from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IPaginationResultFrequencies } from "app/common/interfaces";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";

import { MatMenuModule } from "@angular/material/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";

import { MatSnackBar } from "@angular/material/snack-bar";
import { getCode } from "app/utils/method";
import { Router } from "@angular/router";
import { environment } from "environments/environment.prod";

import { FormApproRejectComponent } from "../../../shared/form-appro-reject/form-appro-reject.component";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import {
  ExportFileFormat,
  ExportRange,
} from "app/layout/export-overlay/tasks/core/export-task.enum";
import { CompanyService } from "../../../configuration/company/company.service.service";
import { MasterUserInterface } from "../../../sales/order-generate/interfaces/master-user.interface";

import { CancelOrderComponent } from "../../../sales/cancel-order/cancel-order.component";

import { UpdateOrderComponent } from "../../../sales/update-order/update-order.component";
import { OrdersListService } from "../../../sales/order-list-components/order-list.service";
import { SelectOrderDetailComponent } from "../../../sales/select-order-detail/select-order-detail.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { IUpdateOrder, IUserApprovalResponse } from "app/modules/components/sales/update-order/interfaces/update-order.interface";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";

@Component({
  selector: "app-table-no-select",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatTabsModule,

    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,

    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    DecimalFormatPipe,
  ],
  templateUrl: "./table-no-select.component.html",
  styleUrl: "./table-no-select.component.scss",
})
export class TableNoSelectComponent {
  @ViewChild(MatSort) sort: MatSort;
  @Input() summaryData: OrderAttributes[] | null = null;
  @Input() UMPActive: boolean = false;
  @Input() servicesFuntion: (sortOrder: string, pageIndex?: number) => void;
  @Input() directionSort: string;
  @Input() isAllColumns: boolean = true;
  @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();

  getCode = getCode;
  projectName = environment.projectName;

  displayedColumns: string[] = [
    "status",
    "statusERP",
    "type",
    "soldTo",
    "documentNumber",
    "class",
    "date",
    "subTotal",
    "total",
  ];

  paymentMethodsDisplayedColumns: string[] = [
    // "inner",
    "paymentMethod",
    "bank",
    "operationNumber",
    "paying",
  ];
  paymentMethodsDataSource = new MatTableDataSource<any>([]);

  dataSource = new MatTableDataSource<OrderAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderAttributes | null = null;

  //DETAIL
  displayedColumnsDetail: string[] = [
    "material",
    "note",
    "warehouse",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "totalSurcharges",
    "totalDiscounts",
    "tax",
    "total" /*, 'actions'*/,
  ];
  dataSourceDetail = new MatTableDataSource<OrderDetailAttributes>([]);

  companyList: CompanyAttributes[] = [];

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;
  selectedStatusERP: number = 0;
  selectedDocumentClass: string = "0";
  selectedSeller: string = "0";
  selectedWithTravel: string = "0";

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Enviado a ERP" },
    { id: 2, name: "Recibido por ERP" },
    { id: 3, name: "Creado en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;
  isErpIntegrated = environment.isErpIntegrated;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  companies: CompanyAttributes[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private readonly ordersListService: OrdersListService,
    private readonly companyService: CompanyService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private exportService: ExportService
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);
  }

  public onSortChange(sort: Sort) {
    const sortColumn = sort.active; // Columna que se está ordenando

    let sortDirection = sort.direction;

    const newDirection = sortDirection === "asc" ? "desc" : "asc"; // Alternar entre asc y desc

    this.sort.direction = newDirection;
    this.servicesFuntion(newDirection.toUpperCase());
  }

  public onSearchInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchChange.emit(target.value.trim());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["summaryData"] && this.summaryData) {
      this.dataSource.data = this.summaryData;
      this.displayedColumns = this.isAllColumns
        ? this.displayedColumns
        : [
            "status",
            "statusERP",
            "type",
            "soldTo",
            "documentNumber",
            "class",
            "subTotal",
            "total",
          ];
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
    }
  }

  ngOnInit(): void {
    if (this.summaryData) {
      this.dataSource.data = this.summaryData;

      this.cdr.detectChanges();
    }
  }

  public updateData(data: OrderAttributes[]) {
    this.dataSource.data = data;
  }

  public onSearchChange(event) {
    const search = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.dataSource.data = this.summaryData.filter((data: any) => {
      return data?.soldTo?.name.toLowerCase().includes(search);
    });
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  openInterval(event) {
    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.getList();

      this.interval = setInterval(() => {
        this.getList();
      }, this.timeInterval);
    } else {
      this.getList();
    }
  }

  getList() {
    //  this.synchronizeDates();
    this.isGlobalSynchronizeAvailable = false;
    this.resetSelection();

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: sortField,
      sortDirection: sortDirection,
    };
    let dataFilter = {
      type: "DT003", // Documentos de carga
      startDate: new Date(
        new Date(this.selectedStartDate).setHours(0, 0, 0, 0)
      ).toISOString(),
      endDate: new Date(
        new Date(this.selectedEndDate).setHours(23, 59, 59, 999)
      ).toISOString(),
      documentClass: this.selectedDocumentClass,
      seller: this.selectedSeller.toString(),
      withTravel: this.selectedWithTravel,
      statusERP: this.selectedStatusERP,
    };

    this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
        this.dataSource.data = res?.data?.data ?? [];
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching quotation list",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getSortField(): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "creationDateTime";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    // this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  resetSelection() {
    this.selection.clear();
  }

  clearFilters(): void {
    const today = new Date();
    this.dateRange.reset({ start: today, end: today });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedStatusERP = 0;
    this.selectedDocumentClass = "0";
    this.selectedSeller = "0";
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  generateOrder(element) {
    let object = {
      quoteId: element._id,
    };
    this.router.navigate(["master", "sales", "order-generate"], {
      queryParams: object,
    });
  }

  onUpdateOrder(order: OrderAttributes): void {
    const dialogRef = this.dialog.open(UpdateOrderComponent, {
      panelClass: "form-modal",
      data: order,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.address = result.data.address;
            order.expeditionCondition = result.data.expeditionCondition;
            order.note = result.data.note;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
    });
  }

  onCancelOrder(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ): void {
    const dialogRef = this.dialog.open(CancelOrderComponent, {
      panelClass: "form-modal",
      data: {
        type: orderDetail ? "DETAIL" : "ORDER",
        order: order,
        orderDetail: orderDetail,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          const detailTemp: OrderDetailAttributes[] = result.data.detail.map(
            (d) => {
              const detailFoundInLocal = this.selectedOrder.detail.find(
                (od) => od.position == d.position
              );
              d["stock"] = detailFoundInLocal
                ? detailFoundInLocal["stock"]
                : [];
              d["stockToValidate"] = detailFoundInLocal
                ? detailFoundInLocal["stockToValidate"]
                : undefined;
              return d;
            }
          );
          this.selectedOrder.detail = detailTemp;
          this.dataSourceDetail.data = this.selectedOrder.detail;
        }
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.reasonForRejection = result.data.reasonForRejection;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
    });
  }

  onChangeSubTotalInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open("La cantidad no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;

    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case "PERCENTAGE":
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case "AMOUNT":
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
    this.calculateOrderTotals(order);
  }

  calculateOrderTotals(order: OrderAttributes): void {
    order.subTotal = 0;
    order.totalDiscounts = 0;
    order.totalSurcharges = 0;
    order.subTotalBeforeTaxes = 0;
    order.totalTaxes = 0;
    order.total = 0;

    order.detail.forEach((od) => {
      if (od.statusId == 1) {
        order.subTotal += od.subTotal;
        order.totalDiscounts += od.totalDiscounts;
        order.totalSurcharges += od.totalSurcharges;
        order.subTotalBeforeTaxes += od.subTotalBeforeTaxes;
        order.totalTaxes += od.totalTaxes;
        order.total += od.total;
      }
    });
    this.cdr.detectChanges();
  }

  onChangeQuantityInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (
      order.class["makesStockValidation"] &&
      orderDetail["stockToValidate"] &&
      orderDetail.soldQuantity > orderDetail["stockToValidate"]
    ) {
      orderDetail.soldQuantity = orderDetail["stockToValidate"];
      this.snackBar.open(
        "La cantidad no debe ser mayor al disponible.",
        "Cerrar",
        { duration: 3000 }
      );
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  onChangePriceInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.unitPrice < 0) {
      orderDetail.unitPrice = 0;
      this.snackBar.open("El precio no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  //aprobar/rechazar
  openModal(element): void {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: { element: element, type: "2" }, //'COTIZACIÓN'
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .subscribe((result: IUserApprovalResponse | "Close" | undefined) => {
        if (result === undefined || result == "Close") {
        } else {
          if (result) {
            let sendOrder: IUpdateOrder = {
              reasonForRejectionId: result.reasonRejectionId ?? null,
              statusId: result.approve
                ? StatusEnum.ORDER_APPROVED
                : StatusEnum.INACTIVE,
            };

            this.updateAppReje(element, sendOrder);
          }
        }
      });
  }

  updateAppReje(element, result) {
    this.ordersListService.update(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  cloneOrder(element: OrderAttributes, type: string) {
    //type: 'copy', 'divide'
    const dialogRef = this.dialog.open(SelectOrderDetailComponent, {
      data: { order: element, type: type },
      disableClose: true,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
      }
    });
  }

  onExportButtonPressed() {
    const id = "sales-quotation-list";
    if (this.exportService.taskIsActive(id)) {
      this.exportService.setVisible(true);
      return;
    }
    this.exportService
      .createForSalesQuotationList(
        this.totalItems,
        this.ordersListService.currentFilter,
        this.ordersListService.currentFilterData,
        ExportRange.CurrentPage,
        ExportFileFormat.Excel
      )
      .start();
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  preparePaymentMethodsData(order: OrderAttributes) {
    /*
    if (!order || !this.relatedPayments) {
      this.paymentMethodsDataSource.data = [];
      return;
    }

    const orderPayments = this.relatedPayments.filter((payment) =>
      this.matchPaymentToOrder(payment, order)
    );

    this.paymentMethodsDataSource.data = orderPayments.map((payment) => ({
      ...payment,
      documentSerial: order.serial,
      paymentType: payment.paymentType?.name || payment.paymentMethod?.name,
      bank: payment.paymentType?.bank || "",
      accountNumber: payment.paymentType?.accountNumber || "",
    }));

    */
  }

  matchPaymentToOrder(payment: any, document: any): boolean {
    const paymentKey = payment.document;
    const documentKey = document.serial;
    return paymentKey === documentKey;
  }

  goToOrder(element: OrderAttributes) {
    if (element?.serial) {
      const queryParams = { orderIds: element?.serial };
      const urlTree = this.router.createUrlTree(
        ["master", "sales", "orders-list"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }
}
